import {
  AddShoppingCartOutlined,
  AutoGraphOutlined,
  CardGiftcardOutlined,
  FactCheckOutlined,
  FireTruckOutlined,
  Inventory2Outlined,
  LibraryAddOutlined,
  MedicalInformationOutlined,
  PaymentOutlined,
  PeopleAltOutlined,
  PercentOutlined,
  PersonAddAlt1Outlined,
  PostAddOutlined,
} from '@mui/icons-material';


import { decodeToken } from "../../utils/settings";
import { useEffect, useState } from "react";
import IconReusable from "../../components/IconReusable";
import { MODULE_PERMISSION_ENUM } from "./Enum";

export const MODULE_TO_SECTION = {
  'business': 'MY BUSINESS',
  'humbee-benefits': 'HUMBEE BENEFITS',
  'analytics': 'ANALYTICS',
  'my-network': 'MY NETWORK',
  'onboard-buyer': 'ONBOARD BUYER',
};
export const useFullMenuStructure = () => {
  const [tokenData, setTokenData] = useState();
  
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };
  
  useEffect(() => {
    getTokenData();
  }, []);
  

  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
  }
  const fullMenuStructure = [
    {
      section: "MY BUSINESS",
      items: [
        {
          key: MODULE_PERMISSION_ENUM.CREATE_PO,
          path: "/create-po",
          icon: <AddShoppingCartOutlined />,
          title: "Create PO",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.PURCHASE_ORDER,
          path: "/po-list",
          icon: <PostAddOutlined />,
          title: "Purchase Order",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.DISPATCH_PLAN,
          path: "/dispatch-status-list",
          icon: <FireTruckOutlined />,
          title: "Dispatch Plan",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.SECONDARY_ORDER,
          path: "/order-booking/secondar-orders-list",
          icon: <LibraryAddOutlined />,
          title: "Secondary Order",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.INVENTORY,
          path: "/inventory",
          icon: <Inventory2Outlined />,
          title: "Inventory",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.PAYMENT,
          path: "/payment",
          icon: <PaymentOutlined />,
          title: "Payment",
          moduleKey: "business",
        },
        {
          key: MODULE_PERMISSION_ENUM.INVOICE,
          path: "/invoice-list",
          icon: <FactCheckOutlined />,
          title: "Invoices",
          moduleKey: "business",
        },
      ],
    },
    {
      section: "MY NETWORK",
      items: [
        {
          title: "Onboard Buyer",
          key: MODULE_PERMISSION_ENUM.ONBOARD_BUYER,
          path: "/onboard-buyer",
          icon: <PersonAddAlt1Outlined />,
          moduleKey: "onboard-buyer",
        },
        {
          title: "My Network",
          key: MODULE_PERMISSION_ENUM.MY_NETWORK,
          path: "/my-network",
          icon: <IconReusable name="Network" size={24} />,
          moduleKey: "onboard-buyer",
        },
      ],
    },
    {
      section: "HUMBEE BENEFITS",
      items: [
        {
          title: "My Benefits",
          key: MODULE_PERMISSION_ENUM.MY_BENEFITS,
          path: "/benefits/mybenefits",
          icon: <MedicalInformationOutlined />,
          moduleKey: "humbee-benefits",
        },
        {
          title: "Beneficiary",
          key: MODULE_PERMISSION_ENUM.BENEFICIARY,
          path: "/beneficiary",
          icon: <PeopleAltOutlined />,
          moduleKey: "humbee-benefits",
        },
        {
          title: "Cumulative TDS",
          key: MODULE_PERMISSION_ENUM.CUMULATIVE_TDS,
          path: "/benefits/cumulative-tds",
          icon: <PercentOutlined />,
          moduleKey: "humbee-benefits",
        },
        {
          title: "My Rewards",
          key: MODULE_PERMISSION_ENUM.MY_REWARDS,
          path: "/benefits/rewards",
          icon: <CardGiftcardOutlined />,
          moduleKey: "humbee-benefits",
        },
        {
          title: "Network Rewards",
          key: MODULE_PERMISSION_ENUM.NETWORK_REWARDS,
          path: "/benefits/network-rewards",
          icon: <CardGiftcardOutlined />,
          moduleKey: "humbee-benefits",
        },
      ],
    },
    {
      section: "ANALYTICS",
      items: [
        {
          title: "Performance",
          key: MODULE_PERMISSION_ENUM.MY_PERFORMANCE,
          path: "/my-performance/Performance",
          icon: <AutoGraphOutlined />,
          moduleKey: "analytics",
        },
        {
          title: "Network Performance",
          key: MODULE_PERMISSION_ENUM.NETWORK_PERFORMANCE,
          path: "/my-performance/network-performance",
          icon: <AutoGraphOutlined />,
          moduleKey: "analytics",
        },
      ],
    },
  ];
  return {
    menuStructure: fullMenuStructure,
  };
};
